import { FallcoClass }    from '../../../classes/FallcoClass';
import { Sanitizer }      from './Sanitizer';
import { StringExtender } from './StringExtender';
import { UrlWorker }      from './UrlWorker';
import { VisualPage }     from './Viewport';
import {merge, difference} from "lodash";
import BrowserDetector     from './BrowserDetector';

import { numberFormat, numberParse }  from '../../../formatters/numberFormat';
import { formatDateHour, formatDate } from '../../../formatters/dateFormat';

import 'mdn-polyfills/Array.prototype.includes';

/**
 * @method append_style_class
 * @param {string} selector
 */

/**
 *
 * @typedef {HTMLStyleElement} StyleElement
 * @property {function} append_style_class
 */

/**
 * @class
 * @extends FallcoClass
 */

class Utilities extends FallcoClass {
  /**
   *
   * @param include_other_libraries
   * @return {*}
   */
  constructor (include_other_libraries) {
    super();
    
    if (include_other_libraries) {
      this.Sanitizer       = Sanitizer;
      this.StringExtender  = StringExtender;
      this.BrowserDetector = BrowserDetector;
      this.UrlWorker       = UrlWorker;
      this.Lodash          = {merge, difference};
      this.VisualPage      = VisualPage;
      this.Formatters      = {
        dateHourFormat: formatDateHour,
        dateFormat:     formatDate,
        numberParse,
        numberFormat
      };
    }
    
    return super.expose_to_public('utilities', this);
  }
  
  /**
   * Dato un elemento, controlla se � un Jquery e se esiste.
   * Ritorna un elemento HTMLElement che pu� essere anche il document nel caso il target sia null.
   *
   * @param {HTMLElement|jQuery} target
   * @param {Boolean} fallback_document=true
   * @return {HTMLElement|null}
   */
  get_js_target (target, fallback_document = true) {
    if (!target && fallback_document) {
      target = document;
    }
    
    if (!target) {
      return null;
    }
    
    if (this.check_type(target, jQuery)) {
      target = target[0];
    }
    
    return target;
  }
  
  /**
   * Ritorna la tipologia di un elemento HTML.
   * Se l'elemento è un input, ne ritorna il 'type'.
   *
   * @param {HTMLElement}target
   */
  get_control_type (target) {
    let local_name = (target.localName || '').toLowerCase();
    let type       = local_name;
    
    if (local_name === 'input') {
      type = target.type;
    }
    
    return type;
  }
  
  /**
   * Permette di creare un oggetto HTMLElement partendo da una stringa,
   * come avviene in jQuery.
   *
   * Se come secondo parametro gli viene passato un oggetto con chiave => valore,
   * cercherà all'interno della stringa, un riferimento $chiave.uppercase$ e lo sostituirà
   * con il valore relativo.
   * Questo consente di avere una sorta di template e compilarne i dati in modo dinamico.
   *
   * @param {String} string
   * @param {Object?} params
   * @return {HTMLCollection | HTMLElement}
   */
  createDOMElement (string, params) {
    /**
     * @type {HTMLElement}
     */
    let wrapper = document.createElement('div');
    
    if (!string) {
      return;
    }
    
    if (params) {
      Object.keys(params).map((key) => {
        let rgexp = new RegExp('(\\$' + key.toUpperCase() + '\\$)', 'g');
        
        string = string.replace(rgexp, params[key]);
      });
    }
    
    wrapper.innerHTML = string;
    
    if (wrapper.children.length === 1) {
      return wrapper.children[0];
    } else {
      return wrapper.children;
    }
  }
  
  /**
   * @deprecated - Use **createDOMElement()**
   * @see createDOMElement
   *
   * @param attrs
   * @returns {HTMLCollection|HTMLElement}
   */
  create_dom_element (...attrs) {
    return this.createDOMElement(...attrs);
  }
  
  /**
   * Ritorna un numero random tra il min ed il max.
   *
   * @param {number} min
   * @param {number} [max]
   * @return {number}
   */
  create_random_int (min, max) {
    let min_val = Math.ceil(max ? min : 0);
    let max_val = Math.floor(max ? max : min);
    
    return Math.floor(Math.random() * (max_val - min_val)) + min_val; //Il max � escluso e il min � incluso
  }
  
  create_object (key, content) {
    let obj = {};
    
    obj[key] = content;
    
    return obj;
  }
  
  /**
   * Genera un ID numerico univoco usando il Timestamp attuale e sommando dei numeri a caso.
   *
   * @deprecated
   * @return {number}
   */
  generate_random_id () {
    return this.generateRandomId();
  }
  
  /**
   * Genera un ID numerico univoco usando il Timestamp attuale e sommando dei numeri a caso.
   *
   * @return {number}
   */
  generateRandomId () {
    return new Date().getTime() + this.create_random_int(99999);
  }
  
  /**
   * Ritorna il nome del file da una strigna di tipo url
   *
   * @param {string} url
   * @return {string}
   */
  get_filename_from_url(url) {
    let split = (url || '').split(/[\\/]/g);
  
    return split[split.length - 1];
  }
  
  /**
   * Ritorna l'estenzione del file dalla stringa del nome
   *
   * @param {string} name
   * @return {string}
   */
  getFileExtensionFromName(name) {
    const regex = /(?:\.([^.]+))?$/;
    
    return regex.exec(name)[1];
  }
  
  /**
   * Ritorna la classe dell'icona Fontawesome del file dalla stringa del nome
   *
   * @param {string} name
   * @return {string}
   */
  getFileIconFromName(name) {
    const extension = this.getFileExtensionFromName(name);
    
    switch (extension) {
      case 'pdf':
        return 'fa-file-pdf'
        break;
      
      case 'doc':
      case 'docx':
        return 'fa-file-word'
        break;
      
      case 'xls':
      case 'xlsx':
        return 'fa-file-excel'
        break;
      
      case 'pps':
      case 'ppt':
        return 'fa-file-powerpoint'
        break;
      
      case 'bmp':
      case 'jpg':
      case 'png':
      case 'tif':
      case 'tiff':
        return 'fa-file-image'
        break;
      
      case 'p7m':
        
        return 'fa-file-signature'
        break;
      
      default:
        return 'fa-file-alt'
        break;
    }
    
    
    return regex.exec(name)[1];
  }
  
  /**
   * Elimina i tag html da una stringa
   *
   * @param {string} string
   * @return {string}
   */
  stripTags(string) {
    let temp_div = document.createElement('div');
    
    temp_div.innerHTML = string;
    
    return temp_div.innerText;
  }
  
  /**
   * Elimina i tag html da una stringa
   *
   * @deprecated
   * @param {string} string
   * @return {string}
   */
  strip_tags (string) {
    return this.stripTags(string);
  }
  
  /**
   * Crea un TAG STYLE e lo aggiunge al header del document passato come parametro.
   * Gli setta anche un ID in modo da essere più facile farvi riferimento
   *
   * @param {String} id
   * @param {Document} doc
   * @return {StyleElement|*}
   */
  create_style_tag (id, doc = document) {
    /**
     * @type {StyleElement}
     */
    let style_element = document.createElement('STYLE');
    
    style_element.id = id;
  
    /**
     * Aggiunge il selettore scelto al tag STYLE.
     *
     * @param {string} selector
     * @param {Object} content
     */
    style_element.append_style_class = (selector, content) => {
      const cssString = this.convert_object_to_css_string(content, true, true);
  
      style_element.innerHTML += `${style_element.innerText ? '\n' : ''}${selector} ${cssString}`;
    };
  
    // Aggiunge al head della pagina il tag appena creato
    doc.head.appendChild(style_element);
  
    return style_element;
  }
  
  /**
   * @deprecated
   * @see {@link convertDataToObject}
   *
   * @param {Object} object
   * @param {Boolean} [noWrap=false]
   * @param {Boolean} [returnBraces=false]
   * @returns {string}
   */
  convert_object_to_css_string (object, noWrap, returnBraces) {
    return this.convertObjectToCssString(object, noWrap, returnBraces);
  }
  
  /**
   * @param {Object} object
   * @param {Boolean} [noWrap=false]
   * @param {Boolean} [returnBraces=false] - indica se il css ritornato deve avere anche le graffe prima e dopo.
   * @returns {string}
   */
  convertObjectToCssString (object, noWrap = false, returnBraces = false) {
    if (!object || object.constructor.name !== 'Object') {
      return '';
    }
    
    const newCssObj = {};
    
    for (let key of Object.keys(object)) {
      const newKey = key.toSnakeCase().replace(/_/g, '-');
      
      newCssObj[newKey] = object[key];
    }
    
    let final_string = JSON.stringify(newCssObj)
      .replace(/",/g, ';' + (!noWrap ? '\n' : ' '))
      .replace(/["]/g, '');
    
    if (!returnBraces) {
      final_string = final_string.replace(/[{}]/g, '');
    } else {
      if (!noWrap) {
        final_string = final_string.replace(/^[{]/, '{\n')
          .replace(/[}]$/, '\n}')
          .replace(/\n(?!})/g, '\n  ');
      }
    }
    
    return final_string;
  }
  
  /**
   * Converte qualsiasi dato passato in un object formato da una key:value.
   * @param {String | Object | Array} entry
   */
  convertDataToObject (entry) {
    let returnObject = {};
    
    if (typeof entry === 'string') {
      decodeURIComponent(entry).split('&').map((stringa) => {
        let str_array              = stringa.split('=');
        returnObject[str_array[0]] = str_array[1];
      });
    } else if (entry instanceof Array) {
      let same_key_index = 0;
      
      for (let i = 0; i < entry.length; i++) {
        let key = entry[i]['name'];
        
        if (key.indexOf('[]') > -1) {
          let new_key = key.replace('[]', '[' + same_key_index + ']');
          
          if (returnObject[new_key]) {
            same_key_index++;
            
            new_key = key.replace('[]', '[' + same_key_index + ']');
          }
          
          key = new_key;
        }
        
        returnObject[key] = entry[i]['value'];
      }
    } else if (typeof entry === 'object') {
      return entry;
    }
    
    return returnObject;
  }
  
  /**
   * Dato un oggetto, controlla e rimuove tutte le Chiavi il cui valore è null o vuoto.
   * Ritorna lo stesso object senza i parametri vuoti.
   *
   * @param {Object} data
   * @return {Object}
   * @private
   */
  removeEmptyParams (data) {
    if (data && data instanceof Object && !(window.FormData && data instanceof window.FormData)) {
      let final_object = {};
      
      Object.keys(data).map(function (key) {
        let value = data[key];
        
        if (value) {
          final_object[key] = value;
        }
      });
      
      return final_object;
    }
    
    return data || {};
  }
  
  /**
   * Effettua il controllo sul tipo di un elemento e ritorna un booleano.
   * I types possono essere un array di costruttori o un singolo construttore
   *
   * @param {HTMLElement} target
   * @param {ObjectConstructor | ObjectConstructor[]} types
   */
  check_type (target, types) {
    if (!target || !target.constructor) {
      return false;
    }
    
    if (!(types instanceof Array)) {
      types = [types];
    }
    
    return types.includes(target.constructor);
  }
  
  /**
   * Effettua un replace del testo contenuto tra gli indici "start" e "end".
   * Se il parametro "start" viene omesso, il replace parte da 0.
   * Se il parametro "end" viene omesso, il replace finisce alla fine del testo.
   *
   * @param {Number?} start
   * @param {Number?} end
   * @param {string} original_string
   * @param {string} to_replace_string
   * @returns {string}
   */
  replace_range (start, end, original_string, to_replace_string) {
    start = start.toString() || 0;
    end   = end.toString() || original_string.length;
    
    return original_string.substring(0, Number(start)) + to_replace_string + original_string.substr(Number(end));
  }
  
  /**
   * Cerca di trasformare un dato in json. Quindi ritorna l'object JSON se il parsing è riuscito,
   * altrimenti ritorna null.
   *
   * @param {string|Object} str
   * @return {object|null}
   */
  tryJsonParse (str) {
    // Indica che è già un object
    if (typeof str === 'object') {
      return str;
    }
    
    // Indica che è una stringa, quindi cerca di fare il parsing
    if (typeof str === 'string') {
      let json;
      
      try {
        json = JSON.parse(str);
        
        return json;
      } catch (e) {
        return null;
      }
    }
    
    return null;
  }
  
  parseFiltersString (str) {
    let url_string = str;
    let url_obj    = {};
    
    if (!url_string) {
      return null;
    }
    
    url_string = decodeURI(url_string);
    
    url_string.split('^').map(function (str) {
      let str_array;
      
      if (str === '') {
        return;
      }
      
      str_array             = str.split('|');
      url_obj[str_array[0]] = str_array[1];
    });
    
    return url_obj;
  }
  
  encodeFiltersObject (obj) {
    let filters = [];
    
    for (let entry of Object.entries(obj)) {
      const name = entry[0];
      let value  = entry[1];
      
      if (value instanceof Array) {
        value = value.join(',');
      }
      
      if (!name || !value) {
        continue;
      }
      
      filters.push(`${name}|${value}`);
    }
    
    return filters.join('^');
  }
  
  /**
   *
   * il parametro forcedType settato a 'Number' forza la trasformazione del valore da stringa a numero prima di effettuare il sort
   *
   * @param {Array} data
   * @param {string|function} key
   * @param {string} [order] - @default: asc
   * @param {string} forcedType - @default: null
   * @returns {this}
   */
  sort(data, key, order = 'asc', forcedType = null) {
    if (!(data instanceof Array)) {
      throw new Error('Il dato non è di tipo Array');
    }
  
    if (!key) {
      throw new Error(`E' necessario specificare il valore key`);
    }
  
    if (typeof key !== 'string' && typeof key !== 'function') {
      throw new Error('Tipo del valore key non valido');
    }
    
    if (typeof key === 'function') {
      key = key();
    }
  
    if (!key || (typeof key !== 'string' && typeof key !== 'function')) {
      throw new Error('Tipo del valore o valore di "key" non valido');
    }
    
    return data.sort((first, second) => {
      let a = (typeof first[key] === 'function' ? first[key]() : first[key]);
      let b = (typeof second[key] === 'function' ? second[key]() : second[key]);
      
      if (typeof a === 'string' && typeof b === 'string') {
        if (forcedType !== 'Number') {
          if (order === 'asc') {
            return a.localeCompare(b);
          }
        } else {
          a = Number(a);
          b = Number(b);
        }
      }
      
      if (a > b) {
        return order === 'desc' ? -1 : 1;
      }
      if (b > a) {
        return order === 'desc' ? 1 : -1;
      }
      return 0;
      
    });
  }
}

export default new Utilities(true);

export { Utilities, Sanitizer, StringExtender, BrowserDetector, UrlWorker, VisualPage };
